module.exports = __webpack_public_path__ + "static/media/iconCCC.f75fa2dc.png";